export const FooterNav: React.FC<{
  children: React.ReactNode;
  title: string;
}> = ({ children, title }) => {
  return (
    <div className="flex flex-col items-start gap-3 max-md:py-6">
      <h3 className="text-base title">{title}</h3>
      <nav className="contents [&>a]:link-hover [&>a]:link">{children}</nav>
    </div>
  );
};
